import React from 'react'
import { ParticipantFormValues } from '../Dashboard/PlanActivity/components/AddParticipantModal';
import { ScoreboardParticipant } from '../../utils/types';
import ScoreboardHeader from './ScoreboardHeader';
import Divider from '@mui/material/Divider';
import { OpenScoreboardData } from '../../services/apiTypes';
import ScoreboardContent from './ScoreboardContent';
import { PaginationInfo } from '../../utils/types';

type ScoreboardBodyProps = {
  onParticipantAdded: (participants: ParticipantFormValues[]) => void,
  isAddingParticipant: boolean,
  participants: ScoreboardParticipant[],
  deleteParticipant: (participantId: number) => void,
  hasParticipants: boolean,
  hasWriteAccess: boolean,
  onDeleteScoreboard: () => void,
  creatorUsername?: string,
  scoreboardResults: OpenScoreboardData[],
  onCreateScoreboardResult: (label: string) => void,
  isCreatingScoreboardResult?: boolean,
  resultsPage: number,
  resultsPaginationInfo?: PaginationInfo,
  hasPreviousResultsPage?: boolean,
  hasNextResultsPage?: boolean,
  gotoNextResultsPage: () => void,
  gotoPreviousResultsPage: () => void,
  isLoadingScoreboardResults?: boolean,
  isErrorScoreboardResults?: boolean,
  scoreboard_id: number,
  defaultNewResultLabel?: string
}

const ScoreboardBody = ({ 
  scoreboardResults,
  isLoadingScoreboardResults,
  isErrorScoreboardResults,
  scoreboard_id,
  resultsPage,
  resultsPaginationInfo,
  hasPreviousResultsPage,
  hasNextResultsPage,
  gotoNextResultsPage,
  gotoPreviousResultsPage,
  ...scoreboardHeaderProps
}: ScoreboardBodyProps) => {
  return (
    <div>
      <ScoreboardHeader {...scoreboardHeaderProps} />
      <Divider sx={{my: 1.5}} />
      <ScoreboardContent
        scoreboard_id={scoreboard_id}
        hasWriteAccess={scoreboardHeaderProps.hasWriteAccess}
        participants={scoreboardHeaderProps.participants}
        scoreboardResults={scoreboardResults}
        resultsPage={resultsPage}
        resultsPaginationInfo={resultsPaginationInfo}
        hasPreviousResultsPage={hasPreviousResultsPage}
        hasNextResultsPage={hasNextResultsPage}
        gotoNextResultsPage={gotoNextResultsPage}
        gotoPreviousResultsPage={gotoPreviousResultsPage}
        isLoading={isLoadingScoreboardResults}
        isError={isErrorScoreboardResults}
      />
    </div>
  )
}

export default ScoreboardBody